export const aciFacebook = {
    iconName: 'facebook',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: {
            attr: {
                d: 'M12.96 24.12c-6.165 0-11.163-4.998-11.163-11.162 0-6.164 4.998-11.16 11.163-11.16s11.163 4.996 11.163 11.16S19.125 24.12 12.96 24.12zm0 0V11.363a3.19 3.19 0 013.19-3.189h.797m-7.974 6.378h7.974',
                stroke: 'currentColor',
                'stroke-width': '1.6',
                'stroke-linecap': 'round',
            },
        },
    },
};
